import store from "../store/index.js"
import {getOssToken} from "@/api/index.js"
let accessid = ''
let policy = ''
let signature = ''
let callbackbody = ''
let key = ''
let expire = store?.state.aliyun_oss?.expire
let host = ''
let g_object_name = ''
let now = Date.parse(new Date()) / 1000;
let aliyun_oss = store?.state.aliyun_oss
// 生成随机字符串
function random_string(len) {
	len = len || 32;
	var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
	var maxPos = chars.length;
	var pwd = '';
	for (let i = 0; i < len; i++) {
		pwd += chars.charAt(Math.floor(Math.random() * maxPos));
	}
	return pwd;
}
// 获取用户上传原始文件名
function get_file_name(filename) {
	let pos = filename.lastIndexOf('.')
	let suffix = ''
	if (pos != -1) {
		suffix = filename.substring(pos)
	}
	return suffix;
}
//  把随机生成的字符串拼接在原始上传文件名后面生成新的唯一文件名
function set_file_name(filename) {
	//let suffix = get_file_name(filename)
	g_object_name = key + filename
	return ''
}

// 获取后端返回的签名信息，生成oss参数
function oss(filename = null) {
	now = Date.parse(new Date()) / 1000;
	console.log(filename,"filenamefilename")
	if (now >  expire) {
		return getOssToken().then(re => {
			store.commit('setAliYunOSS',re.data)
			let res = re.data
			policy = res.policy
			accessid = res.accessKeyId
			signature = res.signature
			host = res.host
			key = res.dir

			if (filename != null) {
				set_file_name(filename)
			}
			// 返回表单上传需要的参数信息
			return {
				'host': host,
				'key': g_object_name,
				'policy': policy,
				'OSSAccessKeyId': accessid,
				'success_action_status': '200', //让服务端返回200,不然，默认会返回204
				'signature': signature,
				'oss_url':res.oss_url,
				'dir' : res.dir
			};
		})
	} else {
		let res = store.state.aliyun_oss
		policy = res.policy
		accessid = res.accessKeyId
		signature = res.signature
		host = res.host
		key = res.dir
		if (filename != null) {
			set_file_name(filename)
		}
		return new Promise((resolve, reject) => {
		   let data = {
		   	'host': host,
		   	'key': g_object_name,
		   	'policy': policy,
		   	'OSSAccessKeyId': accessid,
		   	'success_action_status': '200', //让服务端返回200,不然，默认会返回204
		   	'signature': signature,
		   	'oss_url':res.oss_url,
			'dir' : res.dir
		   };
		    resolve(data);

		});
		return
	}

}

export {
	oss
}
